import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations';
import Loading from "components/Loading";
import Form from "components/Form";
import useId from "hooks/useId";
import {makeStyles} from "@material-ui/core";
import VS from "constants/ValidationShema";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import TextInput from "components/TextInput";
import {connect} from "react-redux";
import PurchasingGroupStage1Service from "services/PurchasingGroupStage1Service";

const useStyle = makeStyles(theme => ({
    wrap: {
        minWidth: 600,
        minHeight: 40
    }
}));


function PapersGeneratorGzmDocumentToSign(
    {
        groupId,
        paper,
        onClose,
        formSubmit
    }) {

    const classes = useStyle();
    const [initData, setInitData] = useState(null)
    const [working, setWorking] = useState(null)

    useEffect(() => {
        PurchasingGroupStage1Service.getGzmDocumentToSign(groupId).then(resp => {
            if (resp) {
                setInitData(resp);
            } else {
                onClose();
            }
        });
        // eslint-disable-next-line
    }, [groupId])

    const formId = useId();
    const onSubmit = (values) => {
        setWorking(true);
        PurchasingGroupStage1Service.printGzmDocumentToSign(groupId, values).finally(onClose)
    }


    const getActions = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), onClose, 'outlined', working));
        buttons.push(createButton(Tr('generate_paper'), () => formSubmit[formId](), undefined, working, undefined, working));
        return <MultiButton buttons={buttons}/>;
    }
    return (
        <Dialog
            open
            title={paper.name}
            titleCentered
            maxWidth="md"
            fullWidth={false}
            onClose={onClose}
            dialogActions={getActions()}
        >
            <div className={classes.wrap}>
                {
                    !initData ?
                        <Loading/> :
                        <>
                            <Form
                                initialValues={initData}
                                validationSchema={VS.object({
                                    projectName: VS.stringMaxNoRq(200)
                                })}
                                onSubmit={onSubmit}
                                id={formId}
                            >
                                {(formikProps) => (<>
                                        <TextInput
                                            id="projectName"
                                            label={Tr("project_name")}
                                            formikProps={formikProps}
                                            disabled={working}
                                            limit={200}
                                        />
                                    </>
                                )}
                            </Form>

                        </>
                }
            </div>
        </Dialog>
    )
}

PapersGeneratorGzmDocumentToSign.propTypes = {
    groupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onClose: PropTypes.func.isRequired,
    paper: PropTypes.object.isRequired
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(PapersGeneratorGzmDocumentToSign);